import Component from '../Component';

const WP_InnerBlocks = wp.blockEditor.InnerBlocks;

export default class InnerBlocks extends Component {
  render() {
    if (this.isView()) {
      return <WP_InnerBlocks.Content/>;
    }

    return <WP_InnerBlocks/>;
  }
}
